import { LoadJson } from '../_fn';

/** 查詢IP網址 */
const IPIFY_URL = 'https://api.ipify.org?format=json';

export const checkIP = ({callback}) => {

  LoadJson(`${window.location.origin}${global.path}/json/hsihungIP.json`)
  .then(function(res) {

    let IP = res;
    console.log('公司 IP：', IP);

    fetch(IPIFY_URL)
    .then(response => response.json())
    .then((data) => {
      console.log('當前 IP 地址：', data.ip);
      let inCompany = IP.find(item => item.ip === data.ip);
      console.log('inCompany', inCompany);

      if (inCompany || window.location.hostname === 'localhost' ) {

        return callback({
          ...inCompany,
          inCompany: true,
          master: global.domain.type === 'master' ? true : false,
        })

      } else {

        // 跳轉
        // let _url = window.location.href;

        // if(global.domain.type === 'dev') {
        //   _url = _url.replace('-dev', '');
        // } else if(global.domain.type === 'test') {
        //   _url = _url.replace('-test', '');
        // }

        // window.location.href = _url;

        return callback({
          ...inCompany,
          inCompany: false,
          master: global.domain.type === 'master' ? true : false,
        })

      }

    }).catch((err) => {
      console.error('無法獲取 IP 地址:', err);
    });


  });

}